import React from "react";
import NumberKeyboard from "../common/numberKeyboard";

const ContactInfoInput = ({
  transformValue,
  formData,
  handleChangeInput,
  determineStepAction,
}) => {
  const maskedPassword = "•".repeat(formData.password?.length || 0);

  return (
    <div className="slideContent" style={{ transform: `translateX(${transformValue}%)` }}>
      <div className="inputBox">
        <div className="inputFields">
          <input type="text" value={maskedPassword} readOnly placeholder="비밀번호 입력" />
        </div>

        <div className="keyboardFields">
          <NumberKeyboard
            type="password"
            handleChangeInput={handleChangeInput}
            inputValue={formData.password}
          />
        </div>

        <div className="inputActions">
          <button type="button" onClick={() => determineStepAction(true)}>
            조회하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoInput;